export default __webpack_public_path__ + "static/media/export.f2d20e29.svg";